<template lang='pug'>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang='sass'>

</style>
